import { LocalizedLink as Link } from "@/components/LocalizedLink";
import { Sparkles, Package, ArrowRight, Zap } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";

interface QuotaReachedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const QuotaReachedDialog = ({ open, onOpenChange }: QuotaReachedDialogProps) => {
  const { language } = useLanguage();

  const tx = (fr: string, en: string, es: string) =>
    language === 'fr' ? fr : language === 'es' ? es : en;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center space-y-3">
          <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Zap className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle className="text-xl">
            {tx(
              "Quota quotidien atteint",
              "Daily quota reached",
              "Cuota diaria alcanzada"
            )}
          </DialogTitle>
          <DialogDescription className="text-base">
            {tx(
              "Vous avez utilisé vos 3 analyses gratuites du jour et vos crédits de bienvenue. Revenez demain ou débloquez plus d'analyses dès maintenant.",
              "You've used your 3 free analyses for today and your welcome credits. Come back tomorrow or unlock more analyses now.",
              "Has usado tus 3 análisis gratuitos de hoy y tus créditos de bienvenida. Vuelve mañana o desbloquea más análisis ahora."
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-4">
          {/* Upgrade plan CTA */}
          <Button className="w-full gap-2" size="lg" asChild>
            <Link to="/pricing" onClick={() => onOpenChange(false)}>
              <Sparkles className="w-4 h-4" />
              {tx(
                "Passer à un forfait",
                "Upgrade to a plan",
                "Mejorar al plan"
              )}
              <ArrowRight className="w-4 h-4 ml-auto" />
            </Link>
          </Button>

          {/* Buy credits CTA */}
          <Button variant="outline" className="w-full gap-2" size="lg" asChild>
            <Link to="/pricing#credits" onClick={() => onOpenChange(false)}>
              <Package className="w-4 h-4" />
              {tx(
                "Acheter des crédits",
                "Buy credits",
                "Comprar créditos"
              )}
            </Link>
          </Button>
        </div>

        <p className="text-xs text-center text-muted-foreground mt-3">
          {tx(
            "À partir de 9€/mois pour 200 analyses",
            "Starting at €9/month for 200 analyses",
            "Desde 9€/mes por 200 análisis"
          )}
        </p>
      </DialogContent>
    </Dialog>
  );
};
